import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    memberRate: Number,
    nonMemberRate: Number
  }

  static targets = ["button", "spinner", "buttonText", "result", "upsellBox", "tierBadge", "feeAmount"]

  async refresh(event) {
    event.preventDefault()

    this.buttonTarget.disabled = true
    this.spinnerTarget.classList.remove("d-none")
    this.buttonTextTarget.textContent = "Checking..."
    this.resultTarget.classList.add("d-none")
    this.resultTarget.className = "refresh-result d-none"

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        }
      })

      const data = await response.json()

      if (!response.ok) {
        this.showResult("error", data.error || "Something went wrong. Please try again.")
        return
      }

      if (data.upgraded) {
        this.showResult("success", `Your membership has been verified! Your new rate is $${Number(data.member_rate).toFixed(2)} — refreshing...`)
        this.updatePricingDisplay(data)

        setTimeout(() => { window.location.reload() }, 2000)
      } else if (data.tier === "member") {
        this.showResult("info", "You're already getting the member rate.")
      } else {
        this.showResult("info", "Your membership status hasn't changed yet. If you just signed up, it may take a few minutes to process.")
      }
    } catch {
      this.showResult("error", "Unable to check membership status. Please try again.")
    } finally {
      this.buttonTarget.disabled = false
      this.spinnerTarget.classList.add("d-none")
      this.buttonTextTarget.textContent = "Refresh Member Status"
    }
  }

  showResult(type, message) {
    this.resultTarget.textContent = message
    this.resultTarget.className = `refresh-result refresh-result--${type}`
    this.resultTarget.classList.remove("d-none")
  }

  updatePricingDisplay(data) {
    if (this.hasUpsellBoxTarget) {
      this.upsellBoxTarget.style.display = "none"
    }

    if (this.hasTierBadgeTarget) {
      this.tierBadgeTarget.className = "mscp-tier-badge mscp-tier-badge--member"
      this.tierBadgeTarget.textContent = "Member"
    }

    if (this.hasFeeAmountTarget) {
      this.feeAmountTarget.textContent = `$${Number(data.member_rate).toFixed(2)}`
    }
  }
}
